import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

import React from "react";

const ButtonWithModalPopup = (props) => {
  const childrenWithProps = React.Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...props });
    }
    return child;
  });
  return (
    <>
      {props.btnComponent(props.onOpen)}
      <Modal
        {...props}
        isOpen={props.isOpen}
        onClose={props.onClose}
        size={props.size || "2xl"}
      >
        <ModalOverlay />
        <ModalContent
          mt={props.mt}
          marginLeft={props.mv}
          marginRight={props.mv}
        >
          <ModalHeader>{props.title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>{childrenWithProps}</ModalBody>
          {/* <ModalFooter>
            <Button colorScheme="blue" mr={3}>
              {props.title}
            </Button>
            <Button onClick={props.onClose}>Cancel</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};
export default ButtonWithModalPopup;
